var React = require('react');

function MenuShapeRectangleInline (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"166.802","y":"32.6041","width":"567.174","height":"567.174","transform":"rotate(13.6864 166.802 32.6041)","stroke":"#FF00FF"}));
}

MenuShapeRectangleInline.defaultProps = {"width":"750","height":"750","viewBox":"0 0 750 750","fill":"none"};

module.exports = MenuShapeRectangleInline;

MenuShapeRectangleInline.default = MenuShapeRectangleInline;
